import { ValidationErrors } from '@angular/forms';
import { ValidationIssue } from '../trip-calculator/types/validation';

export function itineraryValidator(issues: ValidationIssue[]) {
  return (): ValidationErrors | null => {
    const hasIssue = issues.some(
      (issue) => issue.code === 'TRANSPORT_ITINERARY_INVALID',
    );
    return hasIssue ? { invalidItinerary: true } : null;
  };
}
